module.exports = __webpack_public_path__ + "assets/check_green.ba42bfea.svg";